export const NavbarLinks = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Courses",
    // path: '/catalog',
  },
  {
    title: "About Us",
    path: "/about",
  },
  {
    title: "Contact Us",
    path: "/contact",
  },
];
